module.exports = __webpack_public_path__ + "img/security_pic02.cda2e126.jpg";